import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const medianAbsoluteDeviationDescription: CalculatorDescription = {
  id: CalculatorId.MEDIAN_ABSOLUTE_DEVIATION,
  title: 'Median Absolute Deviation Calculator',
  metaTitle: 'Median Absolute Deviation (MAD) Calculator - Robust Measure of Variability',
  description: 'Calculate the median absolute deviation of your dataset for a robust measure of statistical dispersion that is less sensitive to outliers.',
  metaDescription: 'Free online median absolute deviation calculator. Get a robust measure of data variability that is less affected by outliers than mean-based measures.',
  howTo: {
    title: 'How to calculate median absolute deviation',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will compute both population and sample median absolute deviation',
      'View the median value and the typical deviation of values from it',
      'Examine the visualization to understand the data distribution and spread'
    ],
    graphic: {
      description: 'Visual representation of median absolute deviation calculation'
    }
  },
  examples: [
    {
      title: 'Analyzing price variations',
      description: 'Measuring the typical deviation of stock prices from the median',
      dataDescription: 'Daily stock prices over a month with some outliers',
      insights: [
        'MAD is less affected by extreme price movements',
        'Compare with mean absolute deviation to spot outlier influence',
        'Use sample MAD for inferential statistics',
        'Population MAD for descriptive statistics'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'prices',
            name: 'Stock Prices', 
            values: ['50.25', '50.50', '50.75', '51.00', '50.25', '50.75', '65.00', '50.50', '50.25', '35.00', 
                    '50.75', '51.00', '50.25', '50.50', '50.75'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.MEAN_ABSOLUTE_DEVIATION,
    CalculatorId.MEDIAN,
    CalculatorId.STANDARD_DEVIATION
  ]
}; 